import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { LanguageGetService } from '../../services';

export const fetchLanguageGet = createAsyncThunk(
    'languageGet/fetchLanguageGet',
    async ({ id }) => {
        const response = await LanguageGetService(id)
        return response.result;
    }
);

const languageGetSlice = createSlice({
    name: 'languageGet',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchLanguageGet.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchLanguageGet.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchLanguageGet.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default languageGetSlice.reducer;
